import { useCallback, useRef } from 'react';
import { useState } from 'react';
import { safeParseJSONNotRef } from '../utils/jsonValidator';
import { resolveConfig } from '../helpers/configResolver';

export function useResolveBodyData(body_data = {}) {
    const [bodyData, setbodyData] = useState(() => safeParseJSONNotRef(body_data));
    const initialRef = useRef(safeParseJSONNotRef(body_data));

    const setBodyData = useCallback((newData) => {
        const parsed = safeParseJSONNotRef(newData);
        setbodyData(parsed);
        initialRef.current = parsed;
    }, []);

    const processVariables = (body, values) => {
        if (!body?.variables) return body;
        let variables = body.variables;

        for (let key in values) {
            // Keep empty string when the user cleared the field (do not fall back with ||)
            let value = String(values[key] ?? '')
                .replace(/"/g, '\\"')
                .replace(/[\r\n]+/g, ' ');

            if (value === `{${key}}`) value = '';

            variables = variables.toString()
                .replace(`{${key}}`, value)
                .replace(`{[form].${key}}`, value);
        }
        return { ...body, variables };
    };

    /**
     * @param {Object} values - Primary source (form). Empty strings win over secondary.
     * @param {string|null} key - Optional prefix for nested select objects.
     * @param {boolean} fromScratch - Resolve from original bodyData template (avoids baked-in values).
     * @param {Object} secondarySource - Fallback source (e.g. dtoReg + companyInfo).
     */
    const resolveInfo = useCallback((values, key = null, fromScratch = false, secondarySource = {}) => {
        const baseData = fromScratch ? initialRef.current : bodyData;

        const resolved = resolveConfig(baseData, values, secondarySource, key);
        // Form values override secondary when processing variables
        const finalObj = processVariables(resolved, { ...secondarySource, ...values });

        setbodyData(finalObj);
        return finalObj;
    }, [bodyData]);

    const resetInit = useCallback(() => {
        setbodyData(initialRef.current);
    }, []);

    return { bodyData, resolveInfo, resetInit, setBodyData };
}
